import { useEffect } from 'react';
// import * as Sentry from '@sentry/react';

const actions: UIDomain.UIDomainActions = {
	useApolloError(error) {
		useEffect(() => {
			if (error) {
				// Sentry.captureException(error);
				console.log(error);
			}
		}, [error]);
	}
};

export default actions;
